import React from 'react';
import { Heading1, Heading3, Paragraph } from '../../components/typography';
import { Row, Col, Container } from '../../components/grid';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import TheVideoPlayer from '../../components/TheVideoPlayer';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="Video">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>
            Tropekølere og tilslutning af lynkoblinger
          </Heading1>
          <Paragraph>
            Se her hvordan du tropekølere virker og hvordan man tilslutter lynkoblinger på både tropekølere og almindelige fadølsanlæg.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} padding="0">
          <TheVideoPlayer url="QHWD1FOIJAk" thumbnail="tropeanlaeg-skift-lynkobling" />
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>
            Udskrift af video
          </Heading3>
          <Paragraph>
            Har man en stor fest og skal sælge mange fustager, eller hvis man skal kunne
            gøre det på meget kort tid så har vi nogle kraftigere køleanlæg end vores
            standard fadølsanlæg. Til venstre har vi en mini tropekøler og her til højre
            en tropekøler. En mini tropekøler køler dobbelt så godt som et almindeligt
            fadølsanlæg og en tropekøler køler dobbelt så meget som en mini tropekøler
          </Paragraph>
          <Paragraph>
            Begge køleanlæg fungerer præcis på samme måde så vi vil nøjes med at
            demonstrere på tropekøleren. Begge disse tropeanlæg leveres uden særlig
            meget vand, da de ellers kan skvulpe en del under transporten. Det er
            vigtigt når de er stillet op at man tjekker om der er vand nok på. Det kan
            være mange liter der skal fyldes på. Mellem 10 og 20 liter afhængig af hvor
            meget der er i, i forvejen.
          </Paragraph>
          <Paragraph>
            Køleren fyldes op med helt almindeligt vand. Bare hæld på til rørene er
            fuldstændig dækket. Sådan her. Sæt herefter låget på igen. Meningen med
            køleren her er at der er ca. 60 liter vand i anlægget og det skal fryses til
            is, så når den har kørt i nogle timer, så kommer der tyk is rundt om rørene
            her.
          </Paragraph>
          <Paragraph>
            Heroppe har vi motoren, som rører rundt i vandet. Man kan tjekke at det
            fungerer ved at se om der er cirkulation i vandet.  Til denne type anlæg
            bliver udstyret altid leveret i en kasse med ét sæt haner og koblinger pr.
            kasse. I kassen er der spildbakke, koblinger og fadølshane. Det er smartest
            at skrue fadølshanen på baren med det samme. Dernest monteres
            trykregulatoren på kulsyreflasken.
          </Paragraph>
          <Paragraph>
            Så skal øllet tilsluttes. Denne tropekøler kan klare tre haner med tre
            forskellige slags øl tilkoblet. Slangerne er samlet sådan her under
            transporten. Når man skal bruge dem så åbner man lynkoblingen ved at trykke
            på knappen og hive fra hinanden. Dette er indgangen fra fustagen. Så løber
            øllet igennem det store kar med is og vand og kommer ud til hanen herovre.
            Sæt slangen fra fustagen på her og slangen til hanen på herovre.
          </Paragraph>
          <Paragraph>
            Skal man bruge flere haner så er det bare at åbne et sæt mere og sætte
            slangen fra fustagen på og slangen der går op til den ekstra hane. Nu har vi
            altså to der løber ind og to der løber ud og en der ikke er i brug. Når man
            er færdig med at bruge fadølsanlægget så klikker man bare slangerne af. De
            har en automatisk lukkemekanisme der sørger for at der ikke ryger øl ud af
            slangerne når de er åbne. Det er bedst ikke at lukke slangerne efter brug,
            så vi ved hvilke slanger der har været i brug.
          </Paragraph>
          <Paragraph>
            Når man sætter lynkoblingerne sammen er det vigtigt at man trykker dem helt
            sammen så det siger klik. Hvis der er problemer og der ikke kommer øl ud så
            skil dem ad og sæt dem sammen igen. Hvis man skal tappe rigtig mange øl på
            en meget varm sommerdag så kan det være en fordel at lade øllet køre igennem
            mere end én spiral sådan så det bliver kølet ekstra meget.
          </Paragraph>
          <Paragraph>
            Start med at sætte indgangen fra fustagen på her. Åben den næste og sæt
            udgangen til hanen fra den første slange på spiral nummer to. Så sætter man
            hanen på udgangen her. Nu løber øllet igennem tropekøleren to gange.
          </Paragraph>
          <Paragraph>
            Lejer man et anlæg til to typer øl og man ikke skal bruge særligt mange
            fustager, så vil det være almindeligt at man får et køleanlæg og to hanesæt.
            På dette køleanlæg er der mulighed for at tilslutte to fadølshaner og to forskellige fustager.
          </Paragraph>
          <Paragraph>
            Slangerne er sat således at de to yderste slanger er til det ene sæt fustage
            og hane og de to inderste er til det andet sæt. Skal man kun bruge en hane
            så brug det yderste sæt.  Sæt slangen til fadølshanen på i venstre side og
            slangen fra fustagen i højre side. Og med det andet sæt gentages dette i de
            to midterste slanger. Sådan her. Det er vigtigt at slangerne løber i pæne
            bløde buer og at der ikke er knæk på slangen som her.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
